
import { Component, Vue, Watch } from "vue-property-decorator";
import BaseTable from "@/components/BaseTable/index.vue";
import {
  ProductNumberType,
  saveHqNumberType,
  searchHqProductNumberType,
  updateHqNumberType,
  getHqNumberType,
  deleteHqNumberType,
} from "@/api/product-number";
import { Form } from "element-ui";
import { queryAllNumberTypes } from "@/api/number-type"

@Component({
  name: "HqTransactionNumberManagement",
  components: { BaseTable },
})
export default class extends Vue {
  private formDate: ProductNumberType = {} as ProductNumberType;
  private dialogVisible = false;
  private tableData: ProductNumberType[] = [];
  private rules = {
    name: [{ required: true, message: "请输入名称", trigger: "blur" }],
    code: [{ required: true, message: "请输入编码", trigger: "blur" }],
    weight: [
      { required: true, message: "请输入权重", trigger: "blur" },
      {
        validator: (rule, value, callback) => {
          if (!value) {
            callback(new Error("请输入权重"));
          }
          if (value < 0) {
            callback(new Error("权重不能小于0"));
          }
          return callback();
        },
        trigger: "blur",
      },
    ],
  };

  @Watch("dialogVisible", { immediate: true })
  private watchEdit() {
    if (!this.dialogVisible) {
      this.formDate = {} as ProductNumberType;
    }
  }

  private tableCol = [
    { label: "名称", prop: "name", key: "name", width: "100" },
    { label: "编码", prop: "code", key: "code", width: "100" },
    {
      label: "描述",
      prop: "description",
      key: "description",
      width: "100",
    },
    {
      label: "优先级权重",
      prop: "weight",
      key: "weight",
      width: "100",
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      width: "100",
      options: [
        {
          name: "编辑",
          click: "editRow",
          render: () => {
            return true;
          },
        },
        {
          name: "删除",
          code: "",
          click: "handleDelete",
          type: "delete",
        },
      ],
    },
  ];

  private created() {
    this.getList();
    this.queryAllNumberTypes();
  }
  public loading: Boolean = false;
  private async getList() {
    this.loading = true;
    await searchHqProductNumberType().then((res) => {
      this.tableData = res as any;
    });
    this.loading = false;
  }

  private numberType = [] as any;
  private async queryAllNumberTypes() {
    await queryAllNumberTypes().then(res => {
      this.numberType = res
    }).catch(err => {
      console.log(err);
    })
  }

  private showEdit = false;
  private addNumberType() {
    this.dialogVisible = true;
    this.showEdit = false;
  }

  private closeTab() {
    this.dialogVisible = false;
    this.formDate = {} as ProductNumberType;
  }

  private async saveType() {
    let dataForm = this.$refs["formDate"] as Form;
    dataForm.validate(async (valid) => {
      if (valid) {
        this.showEdit
          ? await updateHqNumberType(this.editId, this.formDate)
          : await saveHqNumberType(this.formDate);
        this.formDate = {} as ProductNumberType;
        this.dialogVisible = false;
        this.getList();
        return true;
      }
      return false;
    });
  }

  private editId = '';
  private async editRow(scoop) {
    this.editId = scoop.row.id
    await getHqNumberType(scoop.row.id).then((res:any) => {
      this.formDate = res;
      this.dialogVisible = true;
      this.showEdit = true;
    }).catch(err => {
      console.log(err);
    })
  }

  private changeNumberType(e) {
    let res =  this.numberType.find(item => item.id === e);
    this.formDate.name = res.name;
    this.formDate.code = res.code;
  }

  //  删除
  public async handleDelete(scope) {
    await deleteHqNumberType(scope.row.id);
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }
}
